import React from 'react';

import { Trigger } from "@randajan/jet-react/dom/trigger";

import "./ShopMenuTrigger.scss";
import tab from "@randajan/jet-react/base/tab";
import { useBeam } from '@randajan/bifrost/client/react';
import { shopBeam } from '../../../../config/bifrost';
import { Pane } from '@randajan/jet-react/dom/pane';

export const ShopMenuTrigger = (props) => {
    const { } = props;

    const { data:shop } = useBeam(shopBeam);
    const [menuVisible] = tab.use("menuVisible");

    const onTap = _ => {
        menuVisible.set("", !menuVisible.get());
    }

    return (
        <Pane position="left" transition={{ enter: 400, exit: 1000 }} expand={shop?.isAuthorized} keepMounted appear>
            <Trigger className="ShopMenuTrigger" onTap={onTap} active={menuVisible.get()} switch>
                <div className="MenuIcon">
                    <span />
                    <span />
                    <span />
                </div>
            </Trigger>
        </Pane>
    )
}

